import type { DescriptionPage_CoursePage as DescriptionPageCoursePage } from '__generated__/graphql-types-do-not-use';

import { BEST_PRODUCT_RATING } from 'bundles/seo/common/constants';

export const toEducationLevelValue = (level: DescriptionPageCoursePage['difficultyLevel']) => {
  switch (level) {
    case 'ADVANCED':
      return 'Advanced';
    case 'INTERMEDIATE':
      return 'Intermediate';
    case 'BEGINNER':
      return 'Beginner';
    default:
      return 'Mixed';
  }
};

export const toAggregateRating = (ratings: DescriptionPageCoursePage['ratings']) => {
  const hasValidRatings = ratings?.averageFiveStarRating && ratings.ratingCount;

  return hasValidRatings
    ? ({
        aggregateRating: {
          '@type': 'AggregateRating',
          ratingValue: ratings.averageFiveStarRating,
          bestRating: BEST_PRODUCT_RATING,
          ratingCount: ratings.ratingCount,
        },
      } as const)
    : {};
};
